import React, { useState } from 'react';
import { Box, Chip, Collapse, IconButton, Stack, Typography } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';
import { useOnboarding } from '../../../contexts/onboarding.context';
import { onboardingScreenStates, onboardingStepsOrder } from '../../../utils/constants';

const STEP_LABELS = {
    profile: 'D0b · Boas-vindas',
    connect: 'D0c · Conectar loja',
    promise: 'D01 · A promessa',
    brand: 'D02 · Personalize',
    preview: 'D03 · Ver no celular',
    push: 'D04 · Mande o push',
    conclude: 'D05 · Conclusão'
};

/**
 * Development-only overlay to jump to any screen and switch its state without
 * walking the whole flow. Not rendered in production builds.
 */
export default function DevStateSwitcher() {
    const [isOpen, setIsOpen] = useState(false);
    const { currentStep, goToStep, screenState, setScreenState } = useOnboarding();

    if (process.env.NODE_ENV === 'production') return null;

    const states = onboardingScreenStates[currentStep] || [];

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 16,
                left: 16,
                zIndex: (theme) => theme.zIndex.tooltip,
                backgroundColor: 'rgba(255,255,255,0.97)',
                border: '1px solid rgba(0,0,0,0.15)',
                borderRadius: '12px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                maxWidth: 320
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, px: 1, py: 0.5 }}>
                <IconButton size="small" onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? <CloseIcon fontSize="small" /> : <TuneIcon fontSize="small" />}
                </IconButton>
                <Typography variant="caption" sx={{ fontWeight: 700 }}>
                    {isOpen ? 'Mockup · telas e estados' : 'mockup'}
                </Typography>
            </Box>

            <Collapse in={isOpen}>
                <Box sx={{ p: 1.5, pt: 0 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>Tela</Typography>
                    <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 0.5, mb: 1.5 }}>
                        {onboardingStepsOrder.map((step) => (
                            <Chip
                                key={step}
                                label={STEP_LABELS[step]}
                                size="small"
                                color={step === currentStep ? 'primary' : 'default'}
                                onClick={() => goToStep(step)}
                                sx={{ fontSize: 11 }}
                            />
                        ))}
                    </Stack>

                    {states.length > 1 && (
                        <>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>Estado</Typography>
                            <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 0.5 }}>
                                {states.map((state) => (
                                    <Chip
                                        key={state}
                                        label={state}
                                        size="small"
                                        variant={state === screenState ? 'filled' : 'outlined'}
                                        color={state === screenState ? 'primary' : 'default'}
                                        onClick={() => setScreenState(state)}
                                        sx={{ fontSize: 11 }}
                                    />
                                ))}
                            </Stack>
                        </>
                    )}
                </Box>
            </Collapse>
        </Box>
    );
}
